import { render, staticRenderFns } from "./PageModeratorInstitutionSponsorSponsorshipInstitutionEdit.vue?vue&type=template&id=b4ae82fa&"
import script from "./PageModeratorInstitutionSponsorSponsorshipInstitutionEdit.vue?vue&type=script&lang=js&"
export * from "./PageModeratorInstitutionSponsorSponsorshipInstitutionEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
